<template>
  <div>
    <b-form-input
      v-model="search"
      placeholder="Search projects…"
      size="sm"
      debounce="300"
      class="mb-2"
    />

    <div class="d-flex justify-content-between align-items-center mb-1">
      <small class="text-muted">{{ value.length }} selected</small>
      <div>
        <b-button variant="link" size="sm" class="p-0 mr-3" @click="selectAll"
          >Select all</b-button
        >
        <b-button
          variant="link"
          size="sm"
          class="p-0"
          @click="$emit('input', [])"
          >Clear</b-button
        >
      </div>
    </div>

    <b-overlay :show="loading" rounded="sm">
      <div class="project-scroll border rounded">
        <div
          v-for="p in projects"
          :key="p.id"
          class="project-row"
          :class="{ 'project-row--selected': value.includes(p.id) }"
          @click="toggle(p.id)"
        >
          <span class="project-check" :class="{ active: value.includes(p.id) }">
            <svg
              v-if="value.includes(p.id)"
              width="10"
              height="10"
              viewBox="0 0 10 10"
            >
              <polyline
                points="1.5,5 4,7.5 8.5,2.5"
                stroke="#fff"
                stroke-width="1.8"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="project-name">{{ p.name }}</span>
        </div>

        <div
          v-if="projects.length === 0 && !loading"
          class="text-muted text-center py-4 small"
        >
          No projects found.
        </div>
      </div>
    </b-overlay>

    <div
      v-if="meta && meta.last_page > 1"
      class="mt-2 d-flex justify-content-center"
    >
      <b-pagination
        v-model="page"
        :total-rows="meta.total"
        :per-page="perPage"
        size="sm"
        @change="onPage"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupervisorProjectPicker',

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    perPage: {
      type: Number,
      default: 15,
    },
  },

  data() {
    return {
      projects: [],
      meta: null,
      page: 1,
      search: '',
      loading: false,
    }
  },

  watch: {
    search() {
      this.page = 1
      this.fetch()
    },
  },

  created() {
    this.fetch()
  },

  methods: {
    async fetch() {
      this.loading = true
      try {
        const params = {
          limit: this.perPage,
          page: this.page,
          'filter[is_archived]': 0,
        }
        if (this.search) params['filter[search]'] = this.search
        const { data } = await this.$api.get('projects', { params })
        this.projects = Array.isArray(data.data)
          ? data.data.map((p) => ({ id: p.id, name: p.name }))
          : []
        this.meta = data.meta || null
      } catch (e) {
        this.projects = []
      } finally {
        this.loading = false
      }
    },

    onPage(p) {
      this.page = p
      this.fetch()
    },

    toggle(id) {
      const next = this.value.includes(id)
        ? this.value.filter((x) => x !== id)
        : [...this.value, id]
      this.$emit('input', next)
    },

    selectAll() {
      const merged = [
        ...new Set([...this.value, ...this.projects.map((p) => p.id)]),
      ]
      this.$emit('input', merged)
    },
  },
}
</script>

<style scoped>
.project-scroll {
  max-height: 340px;
  overflow-y: auto;
}

.project-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f1f3f5;
  transition: background 0.1s;
  font-size: 13px;
}
.project-row:last-child {
  border-bottom: none;
}
.project-row:hover {
  background: #f5f7fa;
}
.project-row--selected {
  background: #eef3ff !important;
}

.project-check {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 2px solid #ced4da;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.1s, border-color 0.1s;
}
.project-check.active {
  background: #007bff;
  border-color: #007bff;
}

.project-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
